import React from 'react';
import StartNow from '../../../Common-components/start-now/StartNow';
import "./Solutions.css";
import background from '../../Assets/background_images/background4.png';

const EnglishProficiency = () => {
    return (
        <div>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
        <img className='image' src={background} alt='hiring' />
        <div className='heading'> English Proficiency </div>
        </div>
 
     <div> 
       <h1 className='title'>WHAT IS THE EP ?</h1> 
       <p className='paragraph'> The English Proficiency Assessment (EP) assesses a person's ability to examine written English, utilize precise grammar, comprehend word definitions, and write error-free phrases. Understanding an individual's English proficiency allows the employer to guarantee appropriate communication, which reduces workplace error and risk.  </p>
       <p className='paragraph'>EP assesses an individual's English language abilities by assessing the following characteristics: </p>

        <ul className='outer-list'>
            <li>Error Determination.</li>
            <li>Completion of a Sentence</li>
            <li>Vocabulary.</li>
            <li>Precision in Typing</li>
        </ul>
     </div> 
     <hr />

     <div> 
       <h1 className='title'>BENEFITS OF USING THE EP</h1> 
       <p className='paragraph'>EP may be used to determine the training requirements of new hires as well as existing personnel. Using EP, an employer can learn how to properly train and develop their employees prior to starting a job, rather than discovering their employees' capabilities after the fact.</p>
       <p className='paragraph'>Each report includes management and training tips based on an individual's performance in each section, allowing the employer to create effective and tailored training processes for each individual.</p>
     </div> 
     <hr />

     <div> 
       <h1 className='title'>WHAT IS THE EP ?</h1> 
       <p className='paragraph'>The evaluation can be completed online, from any location where participants have access to the internet (eg. at home, at workplaces, onsite client premises). All internet browsers work on both a PC and a smartphone. </p>
       <p className='paragraph'>The evaluation takes about 25 minutes to complete, but there is no time limit. Participants are asked to respond to evaluation questions based on their immediate impression rather than overthinking how to answer.</p>
       <p className='paragraph'>Strategic Links automatically processes responses and generates a PDF report, which is then emailed to specified parties within 1 hour of survey completion. You may also get reports by logging onto our Strategic Links assessment platform with your personal distinctive user credentials.</p>
     </div> 


     <div style={{textAlign:'center'}}>
       <StartNow/>
     </div>
     </div>
    )
}
 
export default EnglishProficiency;